import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import Styles from './TariffSelectPicker.module.css'
import { SelectPicker } from 'rsuite'
import { IFsvg, IFText, IFSkeleton } from 'Components'
import { Colors } from 'Theme'
import styled from 'styled-components'
import { getEnergyPriceRange } from 'Utils/Calculations'

const StyledSelectPicker = styled(SelectPicker)`
  &.rs-picker-toggle-wrapper .rs-picker-toggle.rs-btn-sm {
    height: ${(props) => props.height || '42px'};
    display: flex;
    ${(props) =>
      props.paddingRight ? `padding-right: ${props.paddingRight};` : ''}
  }
  .rs-stack {
    width: 100%;
  }
  .rs-loader-wrapper {
    padding-left: 0.5rem !important;
  }
`

const TariffSelectPicker = ({
  data,
  onValueChange = () => {},
  initialValue,
  onOpen,
  isLoading,
  currency,
  appearance = 'subtle',
  className,
  height,
  padding,
  searchable = true,
}) => {
  const [value, setValue] = useState(initialValue)
  const [options, setOptions] = useState([])

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const newOptions = data.map((item) => {
        const { min, max } = getEnergyPriceRange(item?.elements || [])
        return {
          label: (
            <div className={Styles.Container}>
              <div className={Styles.LeftContainer}>
                <IFText style={{ color: Colors.text }} className={Styles.Text}>
                  {item.name}
                </IFText>
              </div>
              <div
                className={Styles.CurrentTypeContainer}
                style={{ backgroundColor: Colors.primary + '33' }}
              >
                <IFText
                  style={{
                    color: Colors.LastUpdatedColor,
                    width: '100%',
                  }}
                >
                  {min !== undefined && max !== undefined && (
                    <IFText
                      className={Styles.TariffPriceContainerCenter}
                      style={{
                        textAlign: min === max ? 'center' : 'left',
                      }}
                    >
                      {min === max
                        ? parseFloat(
                            Number(max).toFixed(currency.decimalPlaces || 2),
                          )
                        : `${parseFloat(
                            Number(min).toFixed(currency.decimalPlaces || 2),
                          )} - ${parseFloat(
                            Number(max).toFixed(currency.decimalPlaces || 2),
                          )}`}
                      {currency ? ` ${currency.code}` : ''}
                    </IFText>
                  )}
                </IFText>
              </div>
            </div>
          ),
          value: item._id,
        }
      })
      setOptions(newOptions)
    } else {
      setOptions([])
    }
  }, [data])

  const hasRange =
    Array.isArray(data) &&
    data.some((item) => {
      const { min, max } = getEnergyPriceRange(item?.elements || [])
      return min !== undefined && max !== undefined && min !== max
    })

  return isLoading ? (
    <div style={{ paddingLeft: '1rem' }}>
      <IFSkeleton variant="text" width="13rem" height="3.5rem" />
    </div>
  ) : (
    <StyledSelectPicker
      className={`${Styles.SelectPicker} ${className || ''}`}
      style={{ width: hasRange ? '19rem' : '16rem' }}
      appearance={appearance}
      height={height}
      paddingRight={padding}
      value={value}
      onSelect={(val) => {
        setValue(val)
        onValueChange({
          value: val,
        })
      }}
      data={options}
      cleanable={false}
      size="sm"
      caretAs={() => (
        <div>
          <IFsvg.Down height={20} width={20} fill={Colors.MapSearchBoxIcons} />
        </div>
      )}
      onOpen={onOpen}
      searchable={searchable}
    />
  )
}

TariffSelectPicker.propTypes = {
  data: PropTypes.array.isRequired,
  onValueChange: PropTypes.func,
  initialValue: PropTypes.string,
  onOpen: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default TariffSelectPicker
